import { ksh } from "../lib/format";
import { useCart } from "../context/CartContext";
import { useToast } from "../context/ToastContext";

export default function CartDrawer({ open, onClose, onCheckout }) {
  const { items, changeQty, totalCents } = useCart();
  const toast = useToast();

  const checkout = () => {
    if (items.length === 0) {
      toast("Your cart is empty");
      return;
    }
    onCheckout();
  };

  return (
    <div className={`cart-drawer${open ? " open" : ""}`}>
      <div className="cart-head">
        <h3>
          <i className="fa-solid fa-basket-shopping" /> Your Cart
        </h3>
        <button onClick={onClose}>&times;</button>
      </div>

      <div className="cart-items">
        {items.length === 0 ? (
          <div className="cart-empty">
            <i className="fa-solid fa-basket-shopping" />
            Your cart is empty.
            <br />
            Add products to get started.
          </div>
        ) : (
          items.map((i) => (
            <div className="cart-item" key={i.id}>
              <div style={{ flex: 1 }}>
                <h5>{i.name}</h5>
                <div className="ci-price">
                  Ksh {ksh(i.price)} × {i.qty} = Ksh {ksh(i.price * i.qty)}
                </div>
                <div className="qbox">
                  <button onClick={() => changeQty(i.id, -1)}>−</button>
                  <span>{i.qty}</span>
                  <button onClick={() => changeQty(i.id, 1)}>+</button>
                </div>
                {i.precautions && (
                  <div className="cart-caution">
                    <i className="fa-solid fa-triangle-exclamation" /> {i.precautions}
                  </div>
                )}
              </div>
              <button className="rm" onClick={() => changeQty(i.id, -i.qty)}>
                <i className="fa-solid fa-trash" />
              </button>
            </div>
          ))
        )}
      </div>

      <div className="cart-foot">
        <div className="cart-total">
          <span>Total</span>
          <span>Ksh {ksh(totalCents / 100)}</span>
        </div>
        <button className="checkout-btn" onClick={checkout}>
          <i className="fa-solid fa-mobile-screen-button" /> Pay with M-Pesa
        </button>
        <p className="cart-note">Secure M-Pesa STK push — enter your PIN on your phone to complete the order.</p>
      </div>
    </div>
  );
}
